import { render, staticRenderFns } from "./NotificationBlogs.vue?vue&type=template&id=11f9c5dc"
import script from "./NotificationBlogs.vue?vue&type=script&lang=js"
export * from "./NotificationBlogs.vue?vue&type=script&lang=js"
import style0 from "./NotificationBlogs.vue?vue&type=style&index=0&id=11f9c5dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports